// src/Components/Tournaments/EditTournamentForm.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";
import "./EditTournamentForm.css";

const API = process.env.REACT_APP_API;

function EditTournamentForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  
  const [form, setForm] = useState({name: "", showOnWebsite: true});
  const [loading, setLoading] = useState(false);

  // טען נתוני טורניר קיים
  useEffect(() => {
    const fetchTournament = async () => {
      try {
        const { data } = await axios.get(`${API}/api/tournaments/${id}`);
        setForm({ name: data.name, showOnWebsite: data.showOnWebsite });
      } catch (err) {
        console.error("שגיאה בטעינת טורניר:", err);
        toast.error("❌ שגיאה בטעינת הטורניר");
      }
    };
    if (id) fetchTournament();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        // שליחה ל־ backend
      await axios.put(`${API}/api/tournaments/${id}`, form,
      {
        headers: {
          "Authorization": `Bearer ${token}`, // 👈 חובה
        },
      });
      toast.success('✅ הטורניר עודכן בהצלחה!');
      navigate("/tournaments"); // חזרה לרשימה אחרי שמירה
    } catch (err) {
        console.error("שגיאה בעדכון הטורניר:", err);
        toast.error('❌ עדכון הטורניר נכשל');
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="edit-tournament-form">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon">
          <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon">
          <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
      </div>
    <h3>✏️ עריכת "{form.name}"</h3>
    <form className="form-grid" onSubmit={handleSubmit}>
      <label>שם הטורניר:</label>
      <input
        type="text"
        name="name"
        value={form.name}
        onChange={handleChange}
        required
      />
      <div className="checkbox-group">
        <label>
          <input
            type="checkbox"
            name="showOnWebsite"
            checked={form.showOnWebsite}
            onChange={handleChange}
          />
          מוצג באתר
        </label>
      </div>
      <div className="buttons">
        <button type="submit" disabled={loading}>
          {loading ? "טוען..." : "עדכון הטורניר"}
        </button>
        <button type="button" onClick={() => navigate("/tournaments")}>⬅️ חזרה</button>
      </div>
    </form>
    </div>
  );
}

export default EditTournamentForm;
